function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

class InputWithSuffix {
    constructor(inputSelector, suffixSelector) {
      this.inputElements = document.querySelectorAll(inputSelector);
      this.suffixElements = document.querySelectorAll(suffixSelector);
      this.updateSuffix = this.updateSuffix.bind(this);
      this.inputElements.forEach(input => {
        input.addEventListener('input', this.updateSuffix);
      });
      this.updateSuffix();
    }
  
    updateSuffix() {
        setTimeout(() => {
            this.inputElements.forEach((input, index) => {
                const width = this.getTextWidth(input.value, '22px Averta');
                this.suffixElements[index].style.left = width + 'px';
              });
        }, 50);
    }
  
    getTextWidth(text, font) {
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");
      context.font = font;
      const metrics = context.measureText(text);
      return metrics.width;
    }
  }
  
  const inputWithSuffix = new InputWithSuffix('[input-with-suffix]', '[input-suffix]');



  class WordPluralizer {
    constructor(inputSelector, selectSelector) {
        this.inputElements = document.querySelectorAll(inputSelector);
        this.selectElements = document.querySelectorAll(selectSelector);

        if (this.selectElements) {
            this.selectElements.forEach(select => {
                const elsToPluralize = document.querySelectorAll(select.dataset.pluralizeTarget);
                select.addEventListener('change', () => {
                    this.pluralize(elsToPluralize, select.dataset.pluralizeWord, 1);
                    const inputWithSuffix = new InputWithSuffix('[input-with-suffix]', '[input-suffix]');
                });
            });
        }

        window.addEventListener("productQtyChanged", (event) => {
            const countValue = Number(event.detail);
            this.inputElements.forEach(input => {
                const elsToPluralize = document.querySelectorAll(input.dataset.pluralizeTarget);
                this.pluralize(elsToPluralize, input.dataset.pluralizeWord, countValue);
            });
        });
    }

    pluralize(els, word, count) {
        els.forEach(el => {
            count = parseInt(count); // Convert count to integer
            if (count === 1) {
                el.textContent = word; // Singular form
            } else {
                if (word.endsWith('s') || word.endsWith('x') || word.endsWith('z') || word.endsWith('ch') || word.endsWith('sh')) {
                    // Words ending with 's', 'x', 'z', 'ch', 'sh' - add 'es'
                    el.textContent = word + 'es';
                } else {
                    // Default rule: add 's'
                    el.textContent = word + 's';
                }
            }
        });
    }
}

const wordPluralizer = new WordPluralizer('[input-pluralizer]', '[select-pluralizer]');




  class Pluralizer {
    static pluralize(word, count) {
        if (count === 1) {
            return word; // Singular form
        } else {
            if (word.endsWith('s') || word.endsWith('x') || word.endsWith('z') || word.endsWith('ch') || word.endsWith('sh')) {
                // Words ending with 's', 'x', 'z', 'ch', 'sh' - add 'es'
                return word + 'es';
            } else {
                // Default rule: add 's'
                return word + 's';
            }
        }
    }
}
  

  class MegaMenu extends HTMLElement {
    constructor() {
      super();
      this.activeLink = null;
      this.activeMenu = null;
      this.menuInner = this.querySelector('.mega-menu__inner');
      this.header = document.querySelector('#shopify-section-header');
      this.mainSearch = null;
      this.links = this.header.querySelectorAll('.navigation-snippet .nav-first-level li a');
      this.menuContainers = Array.from(document.querySelectorAll('.mega-menu-container'));
      this.menus = Array.from(document.querySelectorAll('mega-menu'));
      
      this.openMenu = this.openMenu.bind(this);
      this.closeMenu = this.closeMenu.bind(this);
    }
  
    connectedCallback() {
      this.setTargetLinksAsMegaLinks();
      this.megaMenuLinks = Array.from(this.header.querySelectorAll('.mega-menu-link'));

      this.megaMenuLinks.forEach((link) => {
          if (link != this.activeLink) link.addEventListener('mouseenter', () => this.closeMenu());
          link.addEventListener('mouseenter', () => this.openMenu(link.dataset.menu));
      });

      this.links.forEach((link) => {
          link.addEventListener('mouseenter', () => {
              if (link !== this.activeLink) {
                  this.closeMenu();
              }
          });
      });

      this.menuInner.addEventListener('mouseleave', () => {
          this.closeMenu();
      });

      // ADMIN EVENT LISTENERS
      if (Shopify.designMode) {
          document.addEventListener('shopify:block:select', (e) => {
              const targetSection = e.target.closest('.shopify-section');
              const targetMegamenu = targetSection.querySelector('mega-menu');
              if (targetMegamenu) this.openMenu(targetMegamenu.id);
          });

          document.addEventListener('shopify:section:select', (e) => {
              const targetMegamenu = e.target.querySelector('mega-menu');
              if (targetMegamenu) this.openMenu(targetMegamenu.id);
          });

          document.addEventListener('shopify:section:deselect', (e) => {
              this.closeMenu();
          });
      }
  }
  
    openMenu(targetId) {      
      if (!targetId) return; 
      const menu = document.getElementById(targetId);
      const link = document.querySelector(`[data-menu=${targetId}]`);

      if(this.activeMenu && this.activeMenu != menu){
        this.closeMenu;
      } else {
      this.activeMenu = menu;
      this.activeLink = link;
      if (this.activeMenu != null) {
        this.activeLink.setAttribute('open', '');
        this.activeMenu.setAttribute('open', '');
        menu.focus();
      }
      }
    }
  
    setTargetLinksAsMegaLinks() {
      this.links.forEach(link => {
        if(link.dataset.menu == this.id) link.classList.add('mega-menu-link');
      });
    }
  
    closeMenu() {
      if (this.activeMenu) {
        this.activeMenu.removeAttribute('open');
        this.activeLink.removeAttribute('open');
        this.activeMenu = null;
        this.activeLink = null;
        return;
      }
    }

    toggleButtonActive(button) {
      button.hasAttribute('active') ? button.removeAttribute('active') : button.setAttribute('active', '');
    }

    toggleYScroll() {
        document.body.classList.contains('scroll-blocked') 
            ? document.body.classList.remove('scroll-blocked') 
            : document.body.classList.add('scroll-blocked');
    }
  }
  
  customElements.define('mega-menu', MegaMenu);


  class Tabs extends HTMLElement {
    constructor() {
      super();
      this.activeTab = null;
      this.activeTabContent = null;
    }
  
    connectedCallback() {
      this.tabTriggers = this.querySelectorAll('.tab-trigger');
      this.tabContents = this.querySelectorAll('.tab-content');
      this.activeTab = this.tabTriggers[0];
      this.activeTabContent = this.tabContents[0];
      this.attachEvents();
    }
  
    attachEvents() {
    this.tabTriggers.forEach(trigger => {
      trigger.addEventListener('click', () => {
        this.toggleTabs(trigger);
      }); 

      if(this.dataset.interactionType == 'hover'){
        trigger.addEventListener('mouseenter', () => {
          this.toggleTabs(trigger);
        }); 
      }
    });
    }

  
    toggleTabs(tab) {
      if (this.activeTab) {
        this.activeTab.removeAttribute('active');
        this.activeTabContent.removeAttribute('open');
      }
  
      this.activeTab = tab;
      this.activeTabContent = document.getElementById(this.activeTab.dataset.target);
  
      this.activeTab.setAttribute('active', '');
      this.activeTabContent.setAttribute('open', '');
    }
  }
  
  customElements.define('site-tabs', Tabs);


class CustomDrawer extends HTMLElement {
  constructor() {
    super();
    this.activeDrawer = null;
    this.activeButton = null; // Track the currently active button
    this.triggerButtons = Array.from(document.querySelectorAll('[drawer-trigger]'));

    // Bind methods to the class instance
    this.toggleDrawer = this.toggleDrawer.bind(this);
    this.closeDrawer = this.closeDrawer.bind(this);
    this.onSummaryClick = this.onSummaryClick.bind(this);
    this.onCloseButtonClick = this.onCloseButtonClick.bind(this);
  }

  connectedCallback() {
    this.triggerButtons.forEach((button) => {
      button.addEventListener('click', () => this.toggleDrawer(button.dataset.targetDrawer, button));
    });

    document.addEventListener('click', (e) => {
      const clickedTriggerButton = e.target.closest('[drawer-trigger]');

      if (this.activeDrawer && !e.target.closest('.custom-drawer') && !clickedTriggerButton) {
        this.closeDrawer();
      }
    });
  }

  toggleDrawer(targetId, button) {
    if (!targetId) return;

    const drawer = document.getElementById(targetId);

    if (this.activeDrawer && this.activeDrawer !== drawer) {
      this.closeDrawer();
    }

    if (this.activeDrawer === drawer) {
      this.closeDrawer(drawer); // Close if the same drawer is clicked
    } else {
      this.activeDrawer = drawer;
      this.activeButton = button;

      if (this.activeDrawer) {
        this.activeDrawer.setAttribute('open', '');
        this.activeDrawer.focus();
        this.toggleYScroll(true); // Optionally block scroll

        // Add 'active' attribute to the button
        this.activeButton.setAttribute('active', '');

        // Attach listeners to close buttons only when the drawer is opened
        this.activeDrawer.querySelectorAll('.js-close-details').forEach((button) =>
          button.addEventListener('click', this.onCloseButtonClick)
        );
      }
    }
  }

  closeDrawer(drawer = this.activeDrawer) {
    if (drawer) {
      drawer.removeAttribute('open');
      this.toggleYScroll(false); // Optionally unblock scroll

      // Remove 'active' attribute from the previously active button
      if (this.activeButton && this.activeDrawer === drawer) {
        this.activeButton.removeAttribute('active');
        this.activeButton = null;
      }

      if (this.activeDrawer === drawer) {
        this.activeDrawer = null;
      }
    }
  }

  toggleYScroll(blockScroll) {
    document.body.classList.toggle('scroll-blocked', blockScroll);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)').matches) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
      }, 100);
    }
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    this.closeAnimation(detailsElement);
  }
}

// Define the custom element
customElements.define('custom-drawer', CustomDrawer);




class MobileMenuDrawer extends CustomDrawer {
  constructor() {
    super();
  }

  connectedCallback() {
    super.connectedCallback();
    this.attachEvents();
  }

  attachEvents() {
    this.querySelectorAll('.custom-drawer__details > summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );

    this.querySelectorAll('.js-close-details').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)').matches) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
      }, 100);
    }
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }

  onCloseButtonClick(event) {
      const detailsElement = event.currentTarget.closest('details');
      this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    this.closeAnimation(detailsElement);
  }
}

customElements.define('mobile-menu-drawer', MobileMenuDrawer);



class AccordionRow extends HTMLElement {
    constructor() {
      super();
  
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.content = this.querySelector('.accordion__info');
  
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
  
      if(this.summary) this.init(); 
    }
  
    init() {
      this.summary.addEventListener('click', (e) => this.onClick(e));
    }
  
    onClick(e) {
      e.preventDefault();
  
      this.details.style.overflow = 'hidden';
      if (this.isClosing || !this.details.open) {
        this.open();
      }
      else if (this.isExpanding || this.details.open) {
        this.shrink();
      }
    }
  
    shrink() {
      this.isClosing = true;
      
      const summaryStyle = window.getComputedStyle(this.summary);
      const startHeight = `${this.details.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight + parseInt(summaryStyle.marginTop)}px`;
      
      if (this.animation) {
        this.animation.cancel();
      }
      
      this.animation = this.details.animate({
        height: [startHeight, endHeight]
      }, {
        duration: 250,
        easing: 'ease'
      });
      
      this.animation.onfinish = () => this.onAnimationFinish(false);
      this.animation.oncancel = () => this.isClosing = false;
    }
  
    open() {
      this.details.style.height = `${this.details.offsetHeight}px`;
      this.details.open = true;
      window.requestAnimationFrame(() => this.expand());
    }
  
    expand() {
      this.isExpanding = true;
  
      const summaryStyle = window.getComputedStyle(this.summary);
      const startHeight = `${this.details.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight + parseInt(summaryStyle.marginTop) + this.content.offsetHeight}px`;
      
      if (this.animation) {
        this.animation.cancel();
      }
      
      this.animation = this.details.animate({
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'ease-out'
      });
      this.animation.onfinish = () => this.onAnimationFinish(true);
      this.animation.oncancel = () => this.isExpanding = false;
    }
  
    onAnimationFinish(open) {
      this.details.open = open;
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.details.style.height = this.details.style.overflow = '';
    }
  }
  
  customElements.define('accordion-row', AccordionRow);
  
const accordionRow = document.createElement('accordion-row');


class ReadMore {
    constructor(element) {
        this.container = element;
        this.content = this.container.querySelector('.read-more-content');
        this.toggle = this.container.querySelector('.read-more-toggle');
        this.lineHeight = parseFloat(this.container.getAttribute('data-line-height')) || 1.5;
        this.maxLines = Number(this.container.dataset.maxLines) || 3;

        this.isExpanded = false; 
        this.mediaQuery = window.matchMedia('(max-width: 750px)'); // Set media query

        if (this.content && this.toggle) {
            this.init();
        } else {
            console.error('ReadMore: Content or toggle element is missing.');
        }
    }

    init() {
        this.handleResize(); 
        this.mediaQuery.addEventListener('change', () => this.handleResize()); // Listen for screen size changes
        this.toggle.addEventListener('click', () => this.toggleContent());
    }

    handleResize() {
        if (this.mediaQuery.matches) {
            const maxHeight = this.getMaxHeight();
            this.content.style.maxHeight = `${maxHeight}px`;
            this.content.classList.add('collapsed');
            this.toggle.style.display = 'block'; // Show toggle only on smaller screens
        } else {
            this.content.style.maxHeight = '';
            this.content.classList.remove('collapsed', 'expanded');
            this.toggle.style.display = 'none'; // Hide toggle on larger screens
        }
    }

    getMaxHeight() {
        // Calculate line height in pixels based on actual computed line height
        const lineHeightPx = parseFloat(getComputedStyle(this.content).lineHeight);
        return lineHeightPx * this.maxLines; // Maximum height to show 3 lines
    }

    toggleContent() {
        if (!this.mediaQuery.matches) return;

        if (this.isExpanded) {
            // Collapse content
            this.content.classList.remove('expanded');
            this.content.classList.add('collapsed');
            this.content.style.maxHeight = `${this.getMaxHeight()}px`;
            this.toggle.textContent = 'Read more';
        } else {
            // Expand content
            this.content.classList.remove('collapsed');
            this.content.classList.add('expanded');
            this.content.style.maxHeight = `${this.content.scrollHeight}px`; // Expand to full height
            this.toggle.textContent = 'Read less';
        }

        this.isExpanded = !this.isExpanded;
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const readMoreElements = document.querySelectorAll('.read-more-container');
    readMoreElements.forEach(el => new ReadMore(el));
});



// class NotificationHub {
//     constructor() {
//         this.container = document.getElementById('NotificationHub');
//         this.init();
//     }

//     init() {
//         window.addEventListener('pushNotification', this.handlePushNotification.bind(this));
//         document.body.addEventListener('click', (e)=>{
//           if(!e.target.closest('#NotificationHub')){
//             this.closeAllNotifications()
//           }
//         })
//     }

//     handlePushNotification(event) {
//         this.showNotification(this.generateUI(event.detail), event.detail.timeout);
//     }

//     generateUI(notificationData) {
//         const notification = document.createElement('div');
//         let data = notificationData;
//         notification.className = 'site-notification';

//         switch (notificationData.type) {
//             case 'product':
//                 notification.className += ' site-notification--cart';
//                 data = notificationData.added_product;
//                 console.log(data);
//                 notification.innerHTML = `
//                     <div class="site-notification__header">
//                       <strong>${notificationData.title}</strong>
//                       <button onclick="notificationHub.deleteNotification(event)" class="site-notification__delete icon-button">
//                       <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
//                           <path d="M1.125 1.125L13.875 13.875" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
//                           <path d="M13.875 1.125L1.125 13.875" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
//                       </svg>
//                       </button>
//                     </div>
//                     <ul class="site-notification__product-list">
//                         <div class="notification-product-item">
//                           <div class="notification-product-item__media">
//                             <div class="aspect-media aspect-media--rounded aspect-media--square">
//                               <img src="${data.featured_image.url}" alt="${data.featured_image.alt}">
//                             </div>
//                           </div>
//                           <div class="notification-product-item__content">
//                             <h6 class="notification-product-item__title">${data.title}</h6>
//                           </div>
//                         </div>
//                     </ul>
//                     <div class="site-notification__ctas">
//                         <a class="button button--primary button--full-width" href="/cart">View Basket & Checkout</a>
//                         <button onclick="notificationHub.deleteNotification(event)" class="site-link site-link--underline">Continue Shopping</button>
//                     </div>
//                 `;
//                 break;
//             case 'default':
//             default:
//                 notification.innerHTML = `
//                     <button onclick="notificationHub.deleteNotification(event)" class="site-notification__delete icon-button">X</button>
//                     <div class="site-notification__header">${data.title}</div>
//                     <div class="site-notification__content">${data.text}</div>
//                 `;
//                 break;
//         }

//         return notification;
//     }

//     deleteNotification(event) {
//         const button = event.target;
//         const notificationWrapper = button.closest('.notification-hub__item');
//         if (notificationWrapper) {
//             requestAnimationFrame(() => {
//                 notificationWrapper.classList.add('is-hidden');
//                 notificationWrapper.addEventListener('transitionend', () => {
//                     notificationWrapper.remove();
//                 });
//             }); 
//         }
//     }

//     showNotification(notification, customTimeout) {
//         const notificationWrapper = document.createElement('li');
//         const notificationTimeout = customTimeout ? customTimeout : 5000;
//         notificationWrapper.className = 'notification-hub__item';
//         notificationWrapper.appendChild(notification);

//         this.container.appendChild(notificationWrapper);

//         requestAnimationFrame(() => {
//             notificationWrapper.classList.add('is-visible');
//         });

//         setTimeout(() => {
//             requestAnimationFrame(() => {
//                 notificationWrapper.classList.remove('is-visible');
//                 notificationWrapper.classList.add('is-hidden');
//                 notificationWrapper.addEventListener('transitionend', () => {
//                     notificationWrapper.remove();
//                 });
//             });
//         }, notificationTimeout); 
//     }
  
//       closeAllNotifications() {
//         const notifications = this.container.querySelectorAll('.notification-hub__item');
//         notifications.forEach(notificationWrapper => {
//             requestAnimationFrame(() => {
//                 notificationWrapper.classList.remove('is-visible');
//                 notificationWrapper.classList.add('is-hidden');
//                 notificationWrapper.addEventListener('transitionend', () => {
//                     notificationWrapper.remove();
//                 });
//             });
//         });
//     }
  
// }


// const notificationHub = new NotificationHub();

// Select all buttons that should close the modal
const dateModalCloseButtons = document.querySelectorAll('[data-bb-ds-close-modal]');

dateModalCloseButtons.forEach(button => {
  button.addEventListener('click', convertBbDsDataToCart);
});

function convertBbDsDataToCart() {
  const formData = new FormData();

  setTimeout(() => {
    formData.append('attributes[_nominated_date]', localStorage.getItem('bb-ds-date'));
    formData.append('attributes[_nominated_date_formatted]', localStorage.getItem('bb-ds-date-readable'));
    formData.append('attributes[_date_selector_postcode]', localStorage.getItem('bb-ds-postcode'));
    formData.append('attributes[_sample_order_only]', false);
  

    console.log(localStorage.getItem('bb-ds-date-readable'));
    // Send the form data to the server
    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      body: formData
    })
    .then(response => response.json())
    .then(data => console.log('Cart update response:', data))
    .catch(error => console.error('Error updating cart:', error));
  }, 350);
}


class SiteTooltip extends HTMLElement {
  constructor() {
    super();
    this.tooltipText = this.getAttribute('text') || 'Tooltip text';
    this.tooltipElement = null;
    this.isVisible = false;
    this.isSticky = this.hasAttribute('data-sticky');
  }

  connectedCallback() {
    this.addEventListener('mouseenter', this.showTooltip.bind(this));
    this.addEventListener('mouseleave', this.hideTooltip.bind(this));
    window.addEventListener('scroll', this.hideTooltip.bind(this));
    this.addEventListener('touchstart', this.toggleTooltip.bind(this));
    
    if (this.isSticky) {
      this.showTooltip();
    }
  }

  toggleTooltip(event) {
    event.preventDefault();
    this.isVisible ? this.hideTooltip() : this.showTooltip();
  }

  showTooltip() {
    if (this.tooltipElement) return;

    this.tooltipElement = document.createElement('div');
    this.tooltipElement.className = 'tooltip-box';
    this.tooltipElement.textContent = this.tooltipText;

    document.body.appendChild(this.tooltipElement);

    const rect = this.getBoundingClientRect();
    const tooltipRect = this.tooltipElement.getBoundingClientRect();

    let top = rect.top - tooltipRect.height - 8 + window.scrollY;
    let left = rect.left + rect.width / 2 - tooltipRect.width / 2 + window.scrollX;

    if (top < 0) top = rect.bottom + 8 + window.scrollY;
    if (left < 0) left = 8 + window.scrollX;
    if (left + tooltipRect.width > window.innerWidth) left = window.innerWidth - tooltipRect.width - 8 + window.scrollX;

    this.tooltipElement.style.top = `${top}px`;
    this.tooltipElement.style.left = `${left}px`;

    this.tooltipElement.style.visibility = 'visible';
    this.tooltipElement.style.opacity = '1';
    this.isVisible = true;

    if (this.isSticky) {
      this.tooltipElement.classList.add('sticky');
    }
  }

  hideTooltip() {
    if (this.tooltipElement && !this.isSticky) {
      this.tooltipElement.style.visibility = 'hidden';
      this.tooltipElement.style.opacity = '0';
      
      setTimeout(() => {
        if (this.tooltipElement) {
          this.tooltipElement.remove();
          this.tooltipElement = null;
        }
        this.isVisible = false;
      }, 300);
    }
  }

  disconnectedCallback() {
    this.removeEventListener('mouseenter', this.showTooltip);
    this.removeEventListener('mouseleave', this.hideTooltip);
    this.removeEventListener('touchstart', this.toggleTooltip);
  }
}

customElements.define('site-tooltip', SiteTooltip);


class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.IS_OPEN = false;
    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search');

    document.addEventListener('click', (e) => {
      if(!this.IS_OPEN) return;
      if(!e.target.closest('predictive-search')) {
        this.close();
      }
    })
    
    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
  }
  onChange() {
    const searchTerm = this.input.value.trim();
    if (!searchTerm.length) {
      this.close();
      return;
    }
    this.getSearchResults(searchTerm);
  }
  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }
        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.open();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }
  open() {
    this.IS_OPEN = true;
    this.predictiveSearchResults.style.display = 'block';
  }
  close() {
    this.IS_OPEN = false;
    this.predictiveSearchResults.style.display = 'none';
  }
  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
customElements.define('predictive-search', PredictiveSearch);

class ModalOpener extends HTMLElement {
  constructor() {
    super();
    this.triggerButtons = [];
  }

  connectedCallback() {
    // Find all buttons with the `modal-trigger` attribute inside this custom element
    this.triggerButtons = Array.from(this.querySelectorAll('[modal-trigger]'));
    
    // Attach click event listeners to the buttons
    this.triggerButtons.forEach((button) => {
      button.addEventListener('click', (e) => this.onTriggerButtonClick(e));
    });
  }

  onTriggerButtonClick(event) {
    const button = event.currentTarget;
    const targetModal = button.dataset.targetModal;

    // Dispatch a custom event for SiteModal to handle
    this.dispatchEvent(
      new CustomEvent('modal-trigger-click', {
        detail: { targetModal, button },
        bubbles: true,
        composed: true,
      })
    );
  }

  disconnectedCallback() {
    // Clean up event listeners
    this.triggerButtons.forEach((button) =>
      button.removeEventListener('click', this.onTriggerButtonClick)
    );
  }
}

// Define the custom element
customElements.define('modal-opener', ModalOpener);


class SiteModal extends HTMLElement {
  constructor() {
    super();
    this.activeModal = null;
    this.modalOverlay = null;

    // Bind methods to the class instance
    this.toggleModal = this.toggleModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.onCloseButtonClick = this.onCloseButtonClick.bind(this);
  }

  connectedCallback() {
    document.addEventListener('modal-trigger-click', (event) => {
      const { targetModal, button } = event.detail;
      this.toggleModal(targetModal, button);
    });

    document.addEventListener('click', (e) => {
      const clickedTriggerButton = e.target.closest('[modal-trigger]');
      const clickedInsideWrapper = e.target.closest('.site-modal-wrapper');
      const clickedCloseButton = e.target.closest('.js-close-modal');
    
      if (this.activeModal && !clickedInsideWrapper && !clickedTriggerButton) {
        this.closeModal();
      }
    
      if (clickedCloseButton) {
        this.closeModal();
      }
    });


    // Create and append modal overlay to the body
    this.modalOverlay = document.createElement('div');
    this.modalOverlay.className = 'modal-overlay';
    document.body.appendChild(this.modalOverlay);

    // Close modal when clicking the overlay
    this.modalOverlay.addEventListener('click', this.closeModal);
  }

  toggleModal(targetId, button) {
    if (!targetId) return;

    const modal = document.getElementById(targetId);

    if (this.activeModal && this.activeModal !== modal) {
      this.closeModal();
    }

      this.activeModal = modal;
      this.activeButton = button;

      if (this.activeModal) {
        this.activeModal.setAttribute('open', '');
        this.modalOverlay.classList.add('visible');
        this.activeModal.focus();
        this.toggleYScroll(true); // Optionally block scroll

        // Add 'active' attribute to the button
        this.activeButton.setAttribute('active', '');

        // Attach listeners to close buttons only when the modal is opened
        this.activeModal.querySelectorAll('.js-close-modal').forEach((button) =>
          button.addEventListener('click', this.onCloseButtonClick)
        );
      }
    
  }

  closeModal(modal = this.activeModal) {
    if (modal) {
      modal.removeAttribute('open');
      this.modalOverlay.classList.remove('visible');
      this.toggleYScroll(false); // Optionally unblock scroll

      // Remove 'active' attribute from the previously active button
      if (this.activeButton && this.activeModal === modal) {
        this.activeButton.removeAttribute('active');
        this.activeButton = null;
      }

      if (this.activeModal === modal) {
        this.activeModal = null;
      }
    }
  }

  toggleYScroll(blockScroll) {
    document.body.classList.toggle('scroll-blocked', blockScroll);
  }

  onCloseButtonClick(event) {
    const modalElement = event.currentTarget.closest('.site-modal');
    this.closeModal(modalElement);
  }

  disconnectedCallback() {
    // Clean up overlay when the component is removed
    if (this.modalOverlay) {
      this.modalOverlay.removeEventListener('click', this.closeModal);
      document.body.removeChild(this.modalOverlay);
    }
  }
}



// Define the custom element
customElements.define('site-modal', SiteModal);

class ScrollIntoViewButton extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
  }

  handleClick() {
    const targetSelector = this.dataset.target;
    if (targetSelector) {
      const targetElement = document.querySelector(targetSelector);
      if (targetElement) {
        const headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
        
        const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - headerHeight;

        window.scrollTo({ top: targetPosition, behavior: 'smooth' });
        if(targetElement.hasAttribute('data-accordion-item')){
          targetElement.classList.add('accordion--open');
        }
      } else {
        console.error(`Target element with selector ${targetSelector} not found.`);
      }
    } else {
      console.error('No target specified in data-target attribute.');
    }
  }
}

customElements.define('scroll-into-view-button', ScrollIntoViewButton);

class StickyBar extends HTMLElement {
  constructor() {
    super();
    this.target = document.querySelector(this.dataset.target);
    this.ADDITIONAL_OFFSET = Number(this.dataset.offset) || 0;
    this.toggleSticky = this.toggleSticky.bind(this);

    window.addEventListener('scroll', this.toggleSticky);
    window.addEventListener('load', this.toggleSticky);
  }

  toggleSticky() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    const header = document.querySelector('#shopify-section-header');
    const footer = document.querySelector('#shopify-section-footer');
  

    if (!this.target || !footer || !header) return;
    const targetRect = this.target.getBoundingClientRect();
    const targetTop = targetRect.top + window.pageYOffset;
    const targetBottom = targetRect.bottom + window.pageYOffset;
    const footerOffset = footer.offsetTop - this.offsetHeight;


    const targetOutOfViewport = targetRect.bottom < 0 || targetRect.top > window.innerHeight;

    if (targetOutOfViewport && scrollTop + window.innerHeight <= footerOffset) {
        this.setAttribute('is-sticky', '');
        document.body.classList.add('sticky-atc-visible');
    } 
    else if (scrollTop + this.offsetHeight >= footerOffset) {
      this.removeAttribute('is-sticky');
      document.body.classList.remove('sticky-atc-visible');
    } else {
      this.removeAttribute('is-sticky');
      document.body.classList.remove('sticky-atc-visible');
    }
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.toggleSticky);
  }

  static get observedAttributes() {
    return ['data-offset'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-offset') {
      this.ADDITIONAL_OFFSET = Number(newValue) || 0;
    }
  }
}

if (!customElements.get('sticky-bar')) {
  customElements.define('sticky-bar', StickyBar);
}

class StickyFreeSampleButton extends StickyBar {
  constructor() {
    super();
    this.disableSticky = this.disableSticky.bind(this);
    this.disableFreeSampleButtons = this.disableFreeSampleButtons.bind(this);

    // Listen for the "freeSampleAdded" event
    window.addEventListener('freeSampleAdded', (e) => {
      this.disableSticky();
      this.disableFreeSampleButtons(e);
    });
  }

  disableFreeSampleButtons(e) {
    const relatedFreeSampleButtons = document.querySelectorAll(`[${e.detail.targetType}][data-atc-product-id="${e.detail.targetId}"]`);

    relatedFreeSampleButtons.forEach(button => {
      button.setAttribute('disabled', '');
      button.textContent="Sample added";
    })
  }

  disableSticky() {
    // Remove sticky attributes and functionality
    this.removeAttribute('is-sticky');
    document.body.classList.remove('sticky-atc-visible');

    // Disable further sticky behavior by removing scroll and load listeners
    window.removeEventListener('scroll', this.toggleSticky);
    window.removeEventListener('load', this.toggleSticky);
  }

  disconnectedCallback() {
    // Clean up custom event listener in addition to inherited ones
    super.disconnectedCallback();
    window.removeEventListener('freeSampleAdded', this.disableSticky);
  }
}

// Register the new custom element
if (!customElements.get('sticky-free-sample-button')) {
  customElements.define('sticky-free-sample-button', StickyFreeSampleButton);
}


document.addEventListener('DOMContentLoaded', function() {
  const navWrapper = document.querySelector('.navigation-main__content-wrapper');
  const toggleButton = document.querySelector('[aria-label="open navigation"]'); // Replace with your menu toggle button selector

  // Function to toggle the menu
  toggleButton.addEventListener('click', function(event) {
    event.stopPropagation(); // Prevent this click from being considered "outside"
    document.body.classList.toggle('mobile-nav-open');
  });

  // Close the menu when clicking outside
  document.addEventListener('click', function(event) {
    const isClickInsideNav = navWrapper.contains(event.target);
    const isClickOnToggle = toggleButton.contains(event.target);

    if (!isClickInsideNav && !isClickOnToggle) {
      document.body.classList.remove('mobile-nav-open');
    }
  });
});
